import React from 'react';
import { Input, Textarea, Select, Button, PaperClip, DatePicker } from 'components';
import { ProfileService, AuthService } from 'services';
import moment from 'moment';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Globals, Constants, checkPermission } from 'utils';
import { RouteComponentProps } from 'react-router-dom';
import { CopyIcon, CloseRedIcon, FacebookIcon, WhatsappIcon, InstagramIcon, CheckGreenCircle, Menu as MenuIcons } from 'assets/icons';
import { WhiteImage } from 'assets/img';
import { CopyToClipboard } from 'react-copy-to-clipboard';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Api extends React.Component<Props> {

	state = {
		user: null,
		copied: false,
		bearer_token: ''
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Integración API',
				onBack: null,
				subtitle: 'Genera y administra las llaves de acceso para la integración.',
				color: '#f1f3fe',
				icon: MenuIcons.Menu2
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		const res: any = await ProfileService.getApi({
			withoutLoading
		});
		this.setState({
			user: res.user,
			bearer_token: res.user?.bearer_token || ''
		});
	}

	generateToken = () => {
		Globals.confirm('Si genera una nueva llave, la actual dejara de funcionar. ¿Desea continuar?',async () => {
			const res: any = await ProfileService.generateToken();
			if (res.user) {
				this.setState({
					bearer_token: res.user?.bearer_token
				});
			}
			Globals.showSuccess("Se ha generado una nueva llave");
			this.load(true);
		});
	}

	render() {
		const user: any = this.state.user;

		return (
			<div id="client-api">
				<div className="container-api">
					<p className="label-api">Clave de Api</p>
					<div className="container-copy">
						<p>{ this.state.bearer_token }</p>
						<CopyToClipboard text={ this.state.bearer_token } onCopy={ () => {
							this.setState({ copied: true },() => {
								setTimeout(() => {
									this.setState({ copied: false });
								},1500);
							});
						} }>
							<img src={ CopyIcon } />
						</CopyToClipboard>
					</div>
				</div>
				{
					this.state.copied && (
						<p className="copied">Copiada al portapapeles</p>
					)
				}
				{
					checkPermission(Constants.MODULES.CONFIG,'write') && (
						<div className="container-regenerate text-center">
							<button className="btn-regenerate" onClick={ () => this.generateToken() }>
								Regenerar
							</button>
						</div>
					)
				}
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Api);